// src/pages/BenefitsPage.tsx
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader'; // Add this import
import DetailedBenefits from '../components/DetailedBenefits';
import HumanHealthBenefits from '../components/HumanHealthBenefits';
import Footer from '../components/Footer';
import { BACKGROUND_IMAGES } from '../constants/backgrounds';

const BenefitsPage: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark">
      <PageHeader 
        title={t('benefits.page.title', 'Complete Benefits of Vermicompost')}
        subtitle={t('benefits.page.description', 'Discover how our organic vermicompost transforms your soil and boosts plant health beyond conventional fertilizers.')}
        backgroundImage="https://images.unsplash.com/photo-1574943320219-553eb213f72d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" // Rich soil image
      />
      
      <div className="pb-20 px-6">
        <div className="max-w-7xl mx-auto">
          <DetailedBenefits />
          <HumanHealthBenefits />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BenefitsPage;